import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Chip, Stack, Typography, useTheme } from '@mui/material';

const chipStyle = {
  padding: '0.25rem 0.5rem',
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '0.25rem'
};

interface InputSourceButtonsProps {
  buttonId: string;
  handleClick: () => void;
  isActive: boolean;
}

const InputSourceButtonsRow = (props: InputSourceButtonsProps) => {
  const { buttonId, handleClick, isActive } = props;
  const usePalette = useTheme().palette;
  const theme = useTheme();

  return (
    <Chip
      sx={{
        ...chipStyle,
        backgroundColor: isActive ? usePalette.primary.main : 'none',
        '&&:hover': {
          backgroundColor: isActive ? usePalette.primary.main : 'none'
        }
      }}
      onClick={handleClick}
      variant="outlined"
      label={
        <Typography
          fontSize={theme.typography.fontSize}
          style={{
            color: isActive ? usePalette.secondary.light : usePalette.primary.main,
            fontWeight: isActive ? '700' : '400'
          }}>
          <FormattedMessage id={buttonId} />
        </Typography>
      }
    />
  );
};

const inputSources = ['Local', 'Dploy'] as const;
export type InputSourceModes = (typeof inputSources)[number];

interface TestInputSourceButtonsProps {
  buttonClick: (source: InputSourceModes) => void;
  inputSourceMode: InputSourceModes;
}

export const InputSourceButtons = (props: TestInputSourceButtonsProps) => {
  const { buttonClick, inputSourceMode } = props;

  return (
    <Box paddingBottom={2}>
      <Stack direction="row" spacing={0.5}>
        {inputSources.map((sourceMode) => (
          <InputSourceButtonsRow
            key={sourceMode}
            buttonId={sourceMode}
            handleClick={() => buttonClick(sourceMode)}
            isActive={inputSourceMode === sourceMode}
          />
        ))}
      </Stack>
    </Box>
  );
};
